import React, { useRef } from 'react';
import { IndustriesHero } from '../components/industries/IndustriesHero';
import { IndustryExplorer } from '../components/industries/IndustryExplorer';
import { IndustriesCTA } from '../components/industries/IndustriesCTA';
export function Industries() {
  const explorerRef = useRef<HTMLElement>(null);
  return <>
      <IndustriesHero onExplore={() => explorerRef.current?.scrollIntoView({
      behavior: 'smooth'
    })} data-id="element-1219" data-mp="2cad1ronhav92" />
      <IndustryExplorer ref={explorerRef} data-id="element-1220" data-mp="27dcvpdqmpshy" />
      <IndustriesCTA data-id="element-1221" data-mp="22lbpo9k20y0d" />
    </>;
}